export default __webpack_public_path__ + "static/media/user.255c0823.svg";